import { ButtonRoot } from '@/components/common/Button'
import { LinkRoute } from '@/components/common/Link'
import { NavButtonLabel } from '@/components/common/NavButtonLabel'
import { type NavItemType } from '@/defs/nav'
import { buildRoute } from '@/utils/routeUtil'

import styles from '../MenuNavMain.module.scss'

type Props = {
  className?: string
  item: NavItemType
  onClick?: (id: string) => void
  showCaret?: boolean
}

export const MenuNavMainButton = ({ className, item, onClick, showCaret }: Props) => {
  const { hash, id, label, route, submenu } = item
  if (!label) return null

  return route ? (
    <LinkRoute
      analyticsEvent={{ action: 'nav_click', category: 'menu' }}
      className={className}
      hash={hash}
      href={buildRoute(route)}
    >
      <NavButtonLabel item={item} styles={styles} />
    </LinkRoute>
  ) : (
    <ButtonRoot className={className} onClick={onClick ? () => onClick(id) : undefined}>
      <NavButtonLabel item={item} showCaret={showCaret && !!submenu} styles={styles} />
    </ButtonRoot>
  )
}
